import { ssoRefreshTokenLocalStorageName } from '../../constants/localStorage'

export function clearSSORefreshTokenFromLocalStorage(): void {
  global?.window?.localStorage?.removeItem(ssoRefreshTokenLocalStorageName)
}
